import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyANS1yC62R8vbGiTQR3GBsDpEO-tjWqYKw",
  authDomain: "fouratacos.firebaseapp.com",
  projectId: "fouratacos",
  storageBucket: "fouratacos.firebasestorage.app",
  messagingSenderId: "853170221588",
  appId: "1:853170221588:web:e9a6755659c8b7fb426d01",
  measurementId: "G-PN7B2YGSSS"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const functions = getFunctions(app, 'europe-west1');
export const auth = getAuth(app);
